import Reflux from 'reflux';

const NotificationsActions = Reflux.createActions({
  delete: { asyncResult: true },
  list: { asyncResult: true },
});

export default NotificationsActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/notifications/NotificationsActions.jsx